import { rankingItems } from '@/mocks/homeData';

const rankColors: Record<number, string> = {
  1: 'bg-amber-500 text-background-50',
  2: 'bg-foreground-300 text-background-50',
  3: 'bg-amber-700 text-background-50',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 text-center mb-2">
            热度榜单
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
            实时更新的创作竞技排行榜，发现最受欢迎的优秀作品
          </p>

          <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <div
                key={idx}
                className={`flex items-center gap-4 px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
                }`}
              >
                <div
                  className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm flex-shrink-0 ${
                    rankColors[item.rank] || 'bg-background-100 text-foreground-500'
                  }`}
                >
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading font-semibold text-sm text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-3 mt-1 text-xs text-foreground-500">
                    <span>{item.author}</span>
                    <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 text-xs">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="flex items-center gap-1 text-primary-600 font-semibold text-sm whitespace-nowrap">
                  <i className="ri-fire-line text-xs"></i>
                  {item.heat}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}